import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import MLStringBoxViewModelType from '@/ViewModels/Controls/MLStringBoxViewModel';
import TextBoxType from '@/Controls/TextBox';
import DropDownListType from '@/Controls/DropDownList';

export default class MLStringBox extends Control {

    private TextBox = ComponentManager.getControl<typeof TextBoxType>('TextBox');
    private DropDownList = ComponentManager.getControl<typeof DropDownListType>('DropDownList');

    /**
    * Die TextBox des Controls
    */
    private textBox: TextBoxType;

    /**
    * Die DropDownList des Controls
    */
    private dropDownList: DropDownListType;

    /**
    * Das JQuery-Element für das Control
    */
    private jQueryControl: JQuery;

    public constructor(private viewModel: MLStringBoxViewModelType, private element?: JQuery<HTMLElement>) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    /**
     * @override
     */
    public getControl() {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');
        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'mlstringbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.textBox != null) {
            this.textBox = new this.TextBox(this.viewModel.textBox);
            let tuple = this.textBox.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.dropDownList != null) {
            this.dropDownList = new this.DropDownList(this.viewModel.dropDownList);
            let tuple = this.dropDownList.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('MLStringBox', MLStringBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');